// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRevokeTokenRequestDto
 */
export interface IRevokeTokenRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IRevokeTokenRequestDto
     */
    refresh_token: string;
    /**
     * 
     * @type {string}
     * @memberof IRevokeTokenRequestDto
     */
    aud: string;
}

/**
 * Check if a given object implements the IRevokeTokenRequestDto interface.
 */
export function instanceOfIRevokeTokenRequestDto(value: object): value is IRevokeTokenRequestDto {
    if (!('refresh_token' in value) || value['refresh_token'] === undefined) return false;
    if (!('aud' in value) || value['aud'] === undefined) return false;
    return true;
}

export function IRevokeTokenRequestDtoFromJSON(json: any): IRevokeTokenRequestDto {
    return IRevokeTokenRequestDtoFromJSONTyped(json, false);
}

export function IRevokeTokenRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRevokeTokenRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'refresh_token': json['refresh_token'],
        'aud': json['aud'],
    };
}

export function IRevokeTokenRequestDtoToJSON(json: any): IRevokeTokenRequestDto {
    return IRevokeTokenRequestDtoToJSONTyped(json, false);
}

export function IRevokeTokenRequestDtoToJSONTyped(value?: IRevokeTokenRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'refresh_token': value['refresh_token'],
        'aud': value['aud'],
    };
}

